export default {
  List: {
    Title: 'Routines',
    Subtitle: 'Scheduled agent tasks',
    Empty: 'No routines found',
  },
  View: {
    Empty: 'Select a routine to view its details',
    Schedule: 'SCHEDULE',
    Instructions: 'INSTRUCTIONS',
    History: 'RUN HISTORY',
    RunNow: 'Run now',
    Edit: 'Edit',
    Activate: 'Activate',
    Pause: 'Pause',
    LastRan: 'Last ran',
    NextRun: 'Next run',
    Active: 'Active',
    Inactive: 'Inactive',
  },
  Edit: {
    Title: 'Edit Routine',
    TitleLabel: 'Title',
    DescriptionLabel: 'Description',
    InstructionsLabel: 'Instructions',
    ScheduleType: 'Schedule Type',
    TimeLabel: 'Time (HH:MM, 24h)',
    DayOfWeekLabel: 'Day of Week',
    DayOfMonthLabel: 'Day of Month (1–28)',
    MinuteLabel: 'Minute (0–59)',
    ExpressionLabel: 'Expression',
    ExpressionHint: 'AWS EventBridge Scheduler syntax. Rate: rate(5 minutes), rate(1 hour), rate(2 days). Cron: cron(0 9 * * MON-FRI *). Use singular unit when N=1 (rate(1 minute)), plural otherwise (rate(5 minutes)). Timezone only applies to cron expressions, not rate.',
    OneTime: 'One-time',
    DateTimeLabel: 'Run at',
    Save: 'Save changes',
    Cancel: 'Cancel',
  },
};
